// extracted by mini-css-extract-plugin
module.exports = {"invoicetype":"InvoiceType_invoicetype__2icaR","asset":"InvoiceType_asset__1rfXT","download":"InvoiceType_download__19WEO","button":"InvoiceType_button__18-MT"};